import { createSlice } from '@reduxjs/toolkit';

export const yourMetricsSlice = createSlice({
    name: 'yourMetric',
    initialState: {
        cars: null,
    },
    reducers: {
        setYourMetrics: (state, action) => {
            state.cars = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setYourMetrics } = yourMetricsSlice.actions

export default yourMetricsSlice.reducer